import React, { } from 'react';

const Home = () =>  {
    return (
      <div>App Home</div>
    );
}

export default Home;